// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.placeholders-enabled .placeholder {
  cursor: pointer;
  background-color: var(--t-colors-blue-50);
  border: 1px solid var(--t-colors-blue-300);
  border-radius: 4px;
}

.placeholders-enabled .placeholder:empty::before,
.placeholders-enabled .placeholder:empty::after {
  color: var(--t-colors-blue-600);
  font-weight: bold;
}

.placeholders-enabled .placeholder:empty::before {
  content: '{{' attr(data-placeholder);
}

.placeholders-enabled .placeholder:empty::after {
  content: '}}';
}
`, "",{"version":3,"sources":["webpack://./shared/domains/pleditor@next/plugins/Placeholder/style.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,yCAAyC;EACzC,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;;EAEE,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf","sourcesContent":[".placeholders-enabled .placeholder {\n  cursor: pointer;\n  background-color: var(--t-colors-blue-50);\n  border: 1px solid var(--t-colors-blue-300);\n  border-radius: 4px;\n}\n\n.placeholders-enabled .placeholder:empty::before,\n.placeholders-enabled .placeholder:empty::after {\n  color: var(--t-colors-blue-600);\n  font-weight: bold;\n}\n\n.placeholders-enabled .placeholder:empty::before {\n  content: '{{' attr(data-placeholder);\n}\n\n.placeholders-enabled .placeholder:empty::after {\n  content: '}}';\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
